/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/feature_flags/:rollout_id/experiment_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdFeatureFlagsRolloutIdExperimentUsage } from "./constants";
import type { EngagementAppGroupIdFeatureFlagsRolloutIdExperimentUsageResult } from "./types";

export const getEngagementAppGroupIdFeatureFlagsRolloutIdExperimentUsage = reactQueryFetcherAdapter(
  engagementAppGroupIdFeatureFlagsRolloutIdExperimentUsage,
  (
    signal: AbortSignal,
    appGroupId: string,
    rolloutId: string,
    campaignId: string
  ): Promise<EngagementAppGroupIdFeatureFlagsRolloutIdExperimentUsageResult> => {
    return fetch(
      `/engagement/${appGroupId}/feature_flags/${rolloutId}/experiment_usage?exclude_campaign=${campaignId}`,
      "GET",
      {},
      { signal }
    );
  }
);
